/* eslint-disable complexity */
import { API_PATHS, APIClients, Logger, REQUEST_METHODS } from '@futrli/shared-services';

export const ELOQUA_LS_COUNTRY_KEY = 'elq_country';
export const ELOQUA_LS_OPTED_INTO_MARKETING_KEY = 'elq_opted_into_marketing';

/**
 *
 * @returns Referrer for Eloqua POST payload.
 */
export const getEloquaReferrer = () => {
  const referrer = document.referrer;
  let eloquaReferrerHost = '';
  if (referrer) {
    const url = new URL(referrer);
    eloquaReferrerHost = url.host;
  }

  return {
    Referrer_Domain: eloquaReferrerHost
  };
};

/**
 * @returns Eloqua session params. It will first check query params and if there aren't any values there it will check cookies
 */
export const getEloquaSessionParams = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const elqouaSearchParams = {
    utm_campaign: searchParams.get('utm_campaign') || getCookie('utm_campaign') || '',
    utm_source: searchParams.get('utm_source') || getCookie('utm_source') || '',
    utm_medium: searchParams.get('utm_medium') || getCookie('utm_medium') || '',
    utm_content: searchParams.get('utm_content') || getCookie('utm_content') || '',
    utm_term: searchParams.get('utm_term') || getCookie('utm_term') || '',
    gclid: searchParams.get('gclid') || getCookie('gclid') || ''
  };

  return elqouaSearchParams;
};

/**
 * @returns Country payload for Eloqua request. `gdprText` is determined by country value
 */
export const getEloquaCountryPayload = (country?: string | null) => {
  const countryPayload = {
    country: country || '',
    gdprText:
      country === 'Canada' || country === 'United States'
        ? 'By submitting this form, you agree to be contacted with marketing communications.'
        : 'We would like to use the contact details you have provided above to send you Sage marketing emails, and you can opt out at any time. Please see our Privacy Notice for details of how we use your personal data.'
  };

  return countryPayload;
};

/**
 * Returns cookie value by cookie name
 * @param name cookie name
 * @returns Cookie value
 */
export const getCookie = (name: string): string | null => {
  const cookieArray = document.cookie.split(';');
  for (const c of cookieArray) {
    const cookiePair = c.split('=');
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
};

export const sendEloquaRequest = (
  country?: string | null,
  businessPhoneNumber?: string,
  opted_into_marketing?: boolean,
  businessType?: string
) => {
  const elqouaPayload = {
    ...getEloquaSessionParams(),
    ...getEloquaCountryPayload(country),
    ...getEloquaReferrer()
  };

  const eloquaPostData = {
    phone: businessPhoneNumber || '',
    optedIn: opted_into_marketing ? '1' : '0',
    gdpr: opted_into_marketing ? 'Yes' : 'No',
    leadType: businessType === 'I work in a business' ? '' : 'Accountant',
    formURL: window.location.href,
    pageURL: window.location.href,
    ...elqouaPayload
  };

  try {
    APIClients.getAPIClient().makeRequest({
      payload: {
        request: {
          method: REQUEST_METHODS.POST,
          url: API_PATHS.TRIGGER_ELOQUA,
          data: {
            ...eloquaPostData
          }
        }
      }
    });
  } catch (e) {
    Logger.error(e as string);
  }
};
